import { render, staticRenderFns } from "./dealer-balance.vue?vue&type=template&id=2f6990a0&scoped=true&"
import script from "./dealer-balance.vue?vue&type=script&lang=js&"
export * from "./dealer-balance.vue?vue&type=script&lang=js&"
import style0 from "./dealer-balance.vue?vue&type=style&index=0&id=2f6990a0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6990a0",
  null
  
)

export default component.exports